import { useMFAContext } from '@frontend/account';
import { useTranslation } from '@frontend/i18n';
import { Heading } from '@frontend/design-system';

/**
 * The MFA prompt header title is contextual based on the current step
 * and what method is being used. It varies a bit from the MFAFormTitle
 * used in the MFAForm component on the Settings page.
 */
export function MFAPromptTitle() {
  const { t } = useTranslation('account');
  const step = useMFAContext((ctx) => ctx.step);
  const newVerificationMethod = useMFAContext((ctx) => ctx.newVerificationMethod);
  const methodIsEmail = newVerificationMethod.method === 'email';

  let titleString = '';
  switch (step) {
    case 'initial':
      titleString = t('Enable Multi-Factor Authentication');
      break;
    case 'add':
      titleString = methodIsEmail ? t('Enter Your Email Address') : t('Enter Your Phone Number');
      break;
    case 'verify':
      titleString = methodIsEmail ? t('We Emailed You a Code') : t('We Texted You a Code');
      break;
    case 'success':
      titleString = methodIsEmail
        ? t('Multi-Factor Authentication with Email Address is Enabled')
        : t('Multi-Factor Authentication with Phone Number is Enabled');
      break;
    default:
      titleString = t('Multi-Factor Authentication');
      break;
  }

  return <Heading level={3}>{titleString}</Heading>;
}
